'use es6';

import { memo } from 'react';
import I18n from 'I18n';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Button } from 'foundations-components/transitional/components/Button';
import { StyledTd } from './CrossTabStyledComponents';
import { getRowDataElements } from './CrossTabHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CrossTabTotalsRow = ({
  visualization,
  dataColumns,
  labelSpan,
  originalVisualization
}) => {
  const {
    data,
    dataset
  } = visualization;
  const crossTabData = data.getIn([dataset, 'data']);
  const dataValsShared = getRowDataElements(visualization, crossTabData, dataColumns, true, undefined, originalVisualization);
  return /*#__PURE__*/_jsx("tfoot", {
    children: /*#__PURE__*/_jsxs("tr", {
      children: [/*#__PURE__*/_jsx(StyledTd, {
        colSpan: labelSpan,
        isRowHeader: true,
        children: /*#__PURE__*/_jsx(TruncateString, {
          children: I18n.text('report.details.header.REPORT_TOTAL')
        })
      }), dataValsShared.map((val, index) => {
        const onClick = val.get('onClick');
        const label = onClick ? /*#__PURE__*/_jsx(Button, {
          onClick: () => onClick(),
          use: "link",
          children: val.get('label')
        }) : val.get('label');
        return /*#__PURE__*/_jsx(StyledTd, {
          textAlign: val.get('align'),
          children: /*#__PURE__*/_jsx(TruncateString, {
            "data-test-id": `cross-tab-total-cell-${index}`,
            children: label
          })
        }, index);
      })]
    })
  });
};
export default /*#__PURE__*/memo(CrossTabTotalsRow);